import styled from "styled-components";
import { Color, Font, breakpoints,ColorDark } from "@/shared/Constants";

export const Container = styled.div `
  width: 100%;

  .title-stock {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-bottom: 1px solid ${Color.greySeparator};
    padding: 25px 0px 30px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      border-bottom: 1px solid ${ColorDark.greySeparator};
      }
    }
    ${breakpoints.phone} {
      padding: 12px 0px 15px;
    }

    p {
      ${Font.clarinVarSub2Regular}
      font-size: 36px;
      line-height: 28px;
      color: ${Color.grey};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        color: ${ColorDark.textLight};
        }
      }
      ${breakpoints.phone} {
        font-size: 26px;
      }
    }
  }

  .merval-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-top: 20px;
    border-bottom: 1px solid ${Color.greySeparator};
    padding-bottom: 15px;
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      border-bottom: 1px solid ${ColorDark.greySeparator};
      }
    }

    ${breakpoints.phone} {
      flex-direction: column;
    }

    .merval-screener {
      width: calc(100% - (100% / 3));
      border-right: 1px solid ${Color.greySeparator};
      padding-right: 15px;
      ${breakpoints.phone} {
        width: 100%;
        border-right: none;
        padding-bottom: 15px;
        padding-right: 0px;
      }

      ul {
        display: flex;
        flex-direction: row;
        gap: 5px;
        float: right;
        padding-top: 10px;

        ${breakpoints.phone} {
          float: unset;
          border-top: 1px solid ${Color.greySeparator};
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            border-top: 1px solid ${ColorDark.greySeparator};
            }
          }
        }

        li {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 50px;
          ${Font.sansBold}
          font-size: 12px;
          line-height: 20px;
          color: ${Color.white};
          ${breakpoints.phone} {
            font-size: 10px;
          }
          @media (min-width: 976px) and (max-width: 1360px) {
            width: 40px;
          }
        }
      }
      .scale-description {
        ${Font.sansRegular}
        font-size: 12px;
        line-height: 20px;
        color: ${Color.greyCurrency};
        float: right;
        margin-top: 5px;
      }
    }
    .merval-panel {
      padding-left: 15px;

      ${breakpoints.phone} {
        width: 100%;
        border-top: 1px solid ${Color.greySeparator};
        margin-top: 10px;
        padding-top: 15px;
        padding-left: 0px;
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          border-top: 1px solid ${ColorDark.greySeparator};
          }
        }
      }

      table {
        width: 100%;
        table-layout: fixed;
        margin-top: 15px;

        ${breakpoints.phone} {
          margin-top: 5px;
        }

        tr {
          display: flex;
          flex-direction: row;
          padding-bottom: 4px;

          th {
            ${Font.sansRegular}
            font-size: 12px;
            line-height: 20px;
            color: ${Color.grey};
            text-transform: uppercase;
            text-align: left;
            width: 100%;
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              color: ${ColorDark.textLight};
              }
            }
            &:last-child {
              margin-left: 40px;
              
            }

            &:nth-last-child(2n) {
              margin-left: 10px;
            }
          }
          td {
            ${Font.sansLight}
            font-size: 17px;
            line-height: 24px;
            color: ${Color.grey};
            text-align: left;
            width: 100%;
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              color: ${ColorDark.textLight};
              }
            }
            &:last-child {
              margin-left: 40px;
              @media (min-width: 976px) and (max-width: 1360px) {
                margin-right: -25px;
                margin-left: 0px;
              }
            }
            &:nth-last-child(2n) {
              margin-left: 12px;
              @media (min-width: 976px) and (max-width: 1360px) {
                margin-left: -16px;
              }
            
            }

            .variation-negative {
              color: ${Color.mainColor};
              ${breakpoints.darkMode} {
                [data-theme='dark'] & {
                color: ${ColorDark.mainColor};
                }
              }
            }
            .variation-positive {
              color: ${Color.negativeCurrency};
            }

          }
        }
      }
    }

    .merval-screener,
    .merval-panel {
      h2 {
        ${Font.sansBold}
        font-size: 21px;
        line-height: 20px;
        color: ${Color.black000};
        ${breakpoints.darkMode} {
          [data-theme='dark'] & {
          color: ${ColorDark.textLight};
          }
        }
      }
    }
  }
  .last-value {
    margin-top: 23px;
    ${Font.sansRegular}
    font-size: 12px;
    line-height: 20px;
    color: ${Color.greyCurrency};
    text-align: center;
    @media (min-width: 976px) and (max-width: 1360px) {
      line-height: 18px;
      width: 90%;
    }
  }

  .other-currency-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    border-bottom: 1px solid ${Color.greySeparator};
    ${breakpoints.darkMode} {
      [data-theme='dark'] & {
      border-bottom: 1px solid ${ColorDark.greySeparator};
      }
    }
    ${breakpoints.phone} {
      flex-direction: column;
    }

    .card {
      width: 33.3%;
      padding: 15px 0px;
      border-bottom: 1px solid ${Color.greySeparator};
      ${breakpoints.darkMode} {
        [data-theme='dark'] & {
        border-bottom: 1px solid ${ColorDark.greySeparator};
        }
      }

      &:nth-last-child(-n + 1) {
        border-bottom: none;
        ${breakpoints.phone} {
          border-bottom: 1px solid ${Color.greySeparator};
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            border-bottom: 1px solid ${ColorDark.greySeparator};
            }
          }
        }
      }
      &:nth-last-child(3n - 1) {
        .card-content {
          border-right: none;
        }
      }

      ${breakpoints.phone} {
        width: 100%;
        &:last-child {
          border-bottom: none;
        }
      }

      .card-content {
        border-right: 1px solid ${Color.greySeparator};
        height: 310px;
        display: flex;
        padding: 15px;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        padding: 30px;
        ${breakpoints.phone} {
          border-right: none;
          height: 280px;
        }
        .value {
          ${Font.sansLight}
          font-size: 35px;
          line-height: 24px;
          color: ${Color.grey};
          width: 100%;
          padding-bottom: 30px;
          text-align: center;
          @media (min-width: 976px) and (max-width: 1360px) {
            font-size: 28px;
          }
        }
        h2 {
          width: 100%;
          text-align: center;
          ${Font.sansBold}
          font-size: 21px;
          line-height: 24px;
          color: ${Color.black000};
          padding: 15px 0px;
          ${breakpoints.darkMode} {
            [data-theme='dark'] & {
            color: ${ColorDark.textLight};
            }
          }

          @media (min-width: 976px) and (max-width: 1360px) {
            font-size: 16px;
          }
        }
        .currency-info {
          width: 100%;
          padding-bottom: 10px;

          p {
            display: flex;
            justify-content: space-between;
            flex-direction: row;
            ${Font.sansRegular}
            font-size: 12px;
            line-height: 20px;
            text-transform: uppercase;
            color: ${Color.grey};
            align-items: center;
            padding: 15px 0px;
            ${breakpoints.darkMode} {
              [data-theme='dark'] & {
              color: ${ColorDark.textLight};
              }
            }
            span {
              ${Font.sansLight}
              color: ${Color.grey};
              font-size: 22px;
              line-height: 24px;
              ${breakpoints.darkMode} {
                [data-theme='dark'] & {
                color: ${ColorDark.textLight};
                }
              }
              &.variation-negative {
                color: ${Color.mainColor};
              }
              &.variation-positive {
                color: ${Color.negativeCurrency};
              }

              @media (min-width: 976px) and (max-width: 1360px) {
                font-size: 15px;
              }
            }
          }
        }
      }
    }
  }
  .dotted-border {
    background-image: linear-gradient(
      to right,
      #555555 10%,
      rgba(255, 255, 255, 0) 0%
    );
    background-position: bottom;
    background-size: 6.5px 2px;
    background-repeat: repeat-x;
  }
`;